import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TelaMapaUpload from "../../../Components/Common/MapaSVG";
import ListaEspacos from "../../Espacos/Lista";
import TelaConfiguracaoFeira from "../../../Components/Common/ConfiguracaoFeira";
import TelaComercialFeira from "../../../Components/Common/ComercialFeira";
import TelaConfiguracoesKVA from "../../../Components/Common/KVA"

import MapaGerenciamento from "../../../Components/Common/ManutencaoMapa";

import { useNavigate } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { api } from "../../../config";
import classnames from "classnames";
import { parse, format } from "date-fns";
import { ptBR } from "date-fns/locale";

import TagFeiraForm from "../../../Components/Common/TagFeira";
import TelaConfiguracoesTipoEspaco from "../../../Components/Common/TipoEspacoFeira";
import TelaEstandeVendedor from "../../../Components/Common/EstandeVendedor";
import InputMask from "react-input-mask";
import { FeiraProvider } from "../../../Contexts/FeiraContext";

import MapaVisualizador from "../../../Components/Common/MapaIndependente";
import DashboardConfig from "../../../Components/Common/DashboardFeira";
import ListaExpositores from "../../Expositores/Lista/List";
import { fetchComAuth } from '../../../common/api';
import TelaEstacionamentoFeira from "../../../Components/Common/EstacionamentoFeira";
import TelaPavilhaoFeira from "../../../Components/Common/PavilhaoFeira";

import TelaSetor from "../../../Components/Common/Setor";
import TelaCategoria from "../../../Components/Common/Categoria";
import TelaAreaInteresse from "../../../Components/Common/AreaInteresse";
import CadastroRoteamentoMapa from "../../../Components/Common/CadastroRoteamentoMapa";
import TelaConfiguracaoRota from "../../../Components/Common/ConfiguracaoRota";
import VisualizacaoRotaCadastro from "../../../Components/Common/VisualizacaoRotaCadastro";
import CadastroMapaRotaExpositor from "../../../Components/Common/MapaRotaExpositor";
import ListaEspacosRota from "../../EspacosRota/Lista";

const CadastroFeira = () => {
  const [habilitadaVendas, setHabilitadaVendas] = useState(false);
  const [habilitadaRotas, setHabilitadaRotas] = useState(false);
  const [moduloVendas, setModuloVendas] = useState(false);
  const [moduloRotas, setModuloRotas] = useState(false);
  const [renovacao, setRenovacao] = useState(false);
  const [isEditando, setIsEditando] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [dadosAlterados, setDadosAlterados] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); 
  const [feiraSalvaId, setFeiraSalvaId] = useState(null);
  const [activeTabDados, setActiveTabDados] = useState("1"); 
  const [activeTab, setActiveTab] = useState("1");
  const [telefone, setTelefone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const mapaRef = useRef(null);

  const location = useLocation();

  const STORAGE_KEY_TOP = `evomap_top_tab_${id || 'novo'}`;
  const STORAGE_KEY_VENDAS = `evomap_vendas_tab_${id || 'novo'}`;
  const STORAGE_KEY_ROTAS = `evomap_rotas_tab_${id || 'novo'}`;

  const [topBorderTab, settopBorderTab] = useState(() => {
    return localStorage.getItem(STORAGE_KEY_TOP) || "1";
  });

  // Sub-aba de Vendas
  const [activeTabVendas, setActiveTabVendas] = useState(() => {
      return localStorage.getItem(STORAGE_KEY_VENDAS) || "1";
  });

  const [activeTabRotas, setActiveTabRotas] = useState(() => {
      return localStorage.getItem(STORAGE_KEY_ROTAS) || "1";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY_TOP, topBorderTab);
  }, [topBorderTab]);

  // Salva a sub-aba de vendas sempre que mudar
  useEffect(() => {
      localStorage.setItem(STORAGE_KEY_VENDAS, activeTabVendas);
  }, [activeTabVendas]);

   useEffect(() => {
      localStorage.setItem(STORAGE_KEY_ROTAS, activeTabRotas);
  }, [activeTabRotas]);

  useEffect(() => {
    if (location.state && location.state.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location]);
  

  const voltarParaLista = () => {
    localStorage.removeItem(STORAGE_KEY_TOP);
    localStorage.removeItem(STORAGE_KEY_VENDAS);
    localStorage.removeItem(STORAGE_KEY_ROTAS);

    // Adicione as outras chaves de sub-abas aqui conforme replicar
    navigate("/feiras-lista", { replace: true });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoUrl(file);
      setLogoFile(file);
    }
  };

  const formatarDataParaInput = (dataISO) => {
    if (!dataISO) return "";
    return dataISO.split('T')[0]; 
  };

  function limparLogradouro(dados) {
    if (!dados) return "";

    const partes = dados.split(" - ");
    return partes[0].trim(); 
  }

  function pegarComplementoLogradouro(dados) {
    if (!dados) return "";

    const partes = dados.split(" - ");
    return partes[1].trim();
  }

  const buscarCep = async (cep) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (!data.erro) {
        const logradouroLimpo = limparLogradouro(data.logradouro);
        
        document.getElementById("endereco-input").value = logradouroLimpo;
        document.getElementById("bairro-input").value = data.bairro;
        document.getElementById("cidade-input").value = data.localidade;
        document.getElementById("estado-input").value = data.uf;
        document.getElementById("complemento-input").value = pegarComplementoLogradouro(data.logradouro);
      } else {
        alert("CEP não encontrado");
      }
    } catch (error) {
      console.error("Erro ao buscar CEP:", error);
    }
  };

  const removeImage = () => {
    setLogoUrl("");
  };

  const tabChange = (tab) => {
    if (tab !== "1" && !feiraSalvaId) {
      alert("Salve os dados da feira antes de continuar.");
      return;
    }

    if (topBorderTab === "2") { // Módulo Vendas
      setActiveTabVendas(tab);
    } else if (topBorderTab === "3") { // Módulo Rotas
      setActiveTabRotas(tab);
    } else if (topBorderTab === "1") { // Módulo Dados (se precisar de sub-abas internas)
      setActiveTabDados(tab);
    }
    
    setDadosAlterados(false);
  };

  useEffect(() => {
    const carregarFeira = async () => {
      if (!id) {
        document.getElementById("ativo").checked = true;
        return;
      }

      try {
        const response = await fetchComAuth(`${api.API_URL}/feira/${id}`, {
          method: 'GET'
        })

        const data = await response.json();

        if (data && data.data) {
          const feira = data.data;

          document.getElementById("nome-feira-input").value = feira.nome;
          document.getElementById("feira-descricao-input").value = feira.descricao;

          if (feira.data_inicio) {
            const dataInicioLocal = formatarDataParaInput(feira.data_inicio) + "T00:00:00";
            document.getElementById("data-inicio")._flatpickr.setDate(new Date(dataInicioLocal), true);
          }

          if (feira.data_fim) {
              const dataFimLocal = formatarDataParaInput(feira.data_fim) + "T00:00:00";
              document.getElementById("data-fim")._flatpickr.setDate(new Date(dataFimLocal), true);
          }

          if (feira.data_inicio_vendas) {
              const dataInicioVendaLocal = formatarDataParaInput(feira.data_inicio_vendas) + "T00:00:00";
              document.getElementById("data-inicio-venda")._flatpickr.setDate(new Date(dataInicioVendaLocal), true);
          }

          if (feira.data_fim_vendas) {
              const dataFimVendaLocal = formatarDataParaInput(feira.data_fim_vendas) + "T00:00:00";
              document.getElementById("data-fim-venda")._flatpickr.setDate(new Date(dataFimVendaLocal), true);
          }
      
          setTelefone(feira.telefone);
          setWhatsapp(feira.whatsapp);
          document.getElementById("instagram-input").value = feira.instagram;
          document.getElementById("facebook-input").value = feira.facebook;
          document.getElementById("youtube-input").value = feira.youtube;
          document.getElementById("bluesky-input").value = feira.bluesky;
          document.getElementById("spotify-input").value = feira.spotify;
          document.getElementById("tiktok-input").value = feira.tiktok;
          document.getElementById("twitter-input").value = feira.twitter;
          document.getElementById("email-input").value = feira.email;
          document.getElementById("linkedin-input").value = feira.linkedin;

          document.getElementById("cep-input").value = feira.cep;
          document.getElementById("estado-input").value = feira.estado;
          document.getElementById("cidade-input").value = feira.cidade;
          document.getElementById("bairro-input").value = feira.bairro;
          document.getElementById("endereco-input").value = feira.rua;
          document.getElementById("numero-input").value = feira.numero;
          document.getElementById("complemento-input").value = feira.complemento;
          document.getElementById("habilitada_vendas").checked = feira.habilitada_vendas;
          document.getElementById("habilitada_rotas").checked = feira.habilitada_rotas;
          setHabilitadaVendas(feira.habilitada_vendas);
          setHabilitadaRotas(feira.habilitada_rotas);

          setModuloVendas(feira.usa_vendas);
          setModuloRotas(feira.usa_rotas);

          document.getElementById("renovacao").checked = feira.renovacao;
          setRenovacao(feira.renovacao);

          document.getElementById("ativo").checked = feira.ativo;

          setLogoUrl(feira.logoUrl || "");
          setIsEditando(true);
          setFeiraSalvaId(id); // libera as abas
        }
      } catch (err) {
        console.error("Erro ao carregar feira:", err);
      }
    };

    carregarFeira();
  }, [id]);

  const salvarFeira = async () => {
    const nomeInput = document.getElementById("nome-feira-input");
    const descInput = document.getElementById("feira-descricao-input");
    const dataInicioEl = document.getElementById("data-inicio");
    const dataFimEl = document.getElementById("data-fim");
    const dataInicioVendaEl = document.getElementById("data-inicio-venda");
    const dataFimVendaEl = document.getElementById("data-fim-venda");

    const camposObrigatorios = [
      { el: nomeInput, msg: "Informe o nome da feira." },
      { el: descInput, msg: "Informe a descrição." },
      { el: dataInicioEl, msg: "Informe a data de início da feira." },
      { el: dataFimEl, msg: "Informe a data de término da feira." },
      { el: dataInicioVendaEl, msg: "Informe a data de início das vendas." },
      { el: dataFimVendaEl, msg: "Informe a data de fim das vendas." },
    ];

    camposObrigatorios.forEach(({ el }) => el.classList.remove("is-invalid"));

    let erro = false;

    camposObrigatorios.forEach(({ el }) => {
      if (!el.value || el.value.trim() === "") {
        el.classList.add("is-invalid");
        erro = true;
      }
    });

    if (erro) {
      toast.error("Preencha todos os campos obrigatórios.");
      return;
    }

    const metodo = id ? "PUT" : "POST";
    const urlSalvar = id
      ? `${api.API_URL}/feira/${id}`
      : `${api.API_URL}/feira`;

    const nome = document.getElementById("nome-feira-input").value;
    const descricao = document.getElementById("feira-descricao-input").value;
    const data_inicio = format(
      parse(
        document.getElementById("data-inicio").value,
        "dd MMM, yyyy",
        new Date(),
        { locale: ptBR }
      ),
      "yyyy-MM-dd"
    ); //;
    const data_fim = format(
      parse(
        document.getElementById("data-fim").value,
        "dd MMM, yyyy",
        new Date(),
        { locale: ptBR }
      ),
      "yyyy-MM-dd"
    ); 
    const data_inicio_venda = format(
      parse(
        document.getElementById("data-inicio-venda").value,
        "dd MMM, yyyy",
        new Date(),
        { locale: ptBR }
      ),
      "yyyy-MM-dd"
    ); 
    const data_fim_venda = format(
      parse(
        document.getElementById("data-fim-venda").value,
        "dd MMM, yyyy",
        new Date(),
        { locale: ptBR }
      ),
      "yyyy-MM-dd"
    ); 
    const logoInput = document.getElementById("feira-logo-img");
    const instagram = document.getElementById("instagram-input").value;
    const twitter = document.getElementById("twitter-input").value;
    const linkedin = document.getElementById("linkedin-input").value;
    const email = document.getElementById("email-input").value;
    const youtube = document.getElementById("youtube-input").value;
    const spotify = document.getElementById("spotify-input").value;
    const tiktok = document.getElementById("tiktok-input").value;
    const facebook = document.getElementById("facebook-input").value;
    const bluesky = document.getElementById("bluesky-input").value;

    const cep = document.getElementById("cep-input").value;
    const estado = document.getElementById("estado-input").value;
    const cidade = document.getElementById("cidade-input").value;
    const bairro = document.getElementById("bairro-input").value;
    const numero = document.getElementById("numero-input").value;
    const endereco = document.getElementById("endereco-input").value;
    const complemento = document.getElementById("complemento-input").value;

    const habilitada_vendas = document.getElementById("habilitada_vendas").checked;
    const habilitada_rotas = document.getElementById("habilitada_rotas").checked;
    const usa_vendas = document.getElementById("usa_vendas").checked;
    const usa_rotas = document.getElementById("usa_rotas").checked;
    const renovacao = document.getElementById("renovacao").checked;
    const ativo = document.getElementById("ativo").checked;

    if (!nome || !descricao) {
      alert("Preencha os campos obrigatórios");
      return;
    }

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });

    try {
      let logoBase64 = null;

      if (logoFile) {
        logoBase64 = await toBase64(logoFile);
      }

      const formData = new FormData();
      formData.append("nome", nome);
      formData.append("descricao", descricao);
      formData.append("data_inicio", data_inicio);
      formData.append("data_fim", data_fim);
      formData.append("data_inicio_vendas", data_inicio_venda);
      formData.append("data_fim_vendas", data_fim_venda);
      formData.append("whatsapp", whatsapp);
      formData.append("telefone", telefone);
      formData.append("instagram", instagram);
      formData.append("twitter", twitter);
      formData.append("email", email);
      formData.append("linkedin", linkedin);
      formData.append("bluesky", bluesky);
      formData.append("youtube", youtube);
      formData.append("facebook", facebook);
      formData.append("tiktok", tiktok);
      formData.append("spotify", spotify);

      formData.append("cep", cep);
      formData.append("estado", estado);
      formData.append("cidade", cidade);
      formData.append("bairro", bairro);
      formData.append("numero", numero);
      formData.append("rua", endereco);
      formData.append("complemento", complemento);

      formData.append("habilitada_vendas", habilitada_vendas);
      formData.append("habilitada_rotas", habilitada_rotas);
      formData.append("usa_vendas", usa_vendas);
      formData.append("usa_rotas", usa_rotas);
      formData.append("renovacao", renovacao);
      formData.append("ativo", ativo);

      if (id) formData.append("id", id);

      if (logoFile) {
        formData.append("logo", logoBase64);
      }

      const response = await fetchComAuth(urlSalvar, {
        method: metodo,
        body: formData,
      });
      
      const json = await response.json();
      setFeiraSalvaId(json.data);
      setIsEditando(true);

      setTimeout(() => {
        toast.success("Feira salva com sucesso!");
      }, 300);
    } catch (err) {
      console.error("Erro ao salvar feira:", err);
      toast.error("Erro ao salvar os dados informados da feira!");
    }
  };

  const [outlineBorderNav, setoutlineBorderNav] = useState("1");
    const outlineBorderNavtoggle = (tab) => {
        if (outlineBorderNav !== tab) {
            setoutlineBorderNav(tab);
        }
    };
      // Border Top Nav
  const topBordertoggle = (tab) => {
    if (topBorderTab !== tab) {
        settopBorderTab(tab);
        localStorage.setItem(STORAGE_KEY_TOP, tab); // Persiste imediatamente
    }
  };
  
  const cardCursorPointer = {
    cursor: "pointer"
  }

  document.title = "Cadastro de Feira | EVOMAP - Tecnologia que conecta negócios";

  return (
    <React.Fragment>
      {/* <ToastContainer closeButton={false} /> */}

      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Cadastro Feira" pageTitle="Feiras" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="text-start mb-4">
                    <button
                      type="submit"
                      className="btn btn-primary w-sm me-1"
                      onClick={() =>
                        navigate("/feiras-lista", { replace: true })
                      }
                    >
                      Voltar
                    </button>
                  </div>

                  <Nav tabs className="nav nav-tabs nav-justified nav-border-top nav-border-top-primary mb-3">
                    <NavItem>
                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: topBorderTab === "1", })} onClick={() => { topBordertoggle("1"); }} >
                          <i className="mdi mdi-briefcase align-middle me-1"></i> Dados
                        </NavLink>
                    </NavItem>
                    {moduloVendas && (
                      <NavItem>
                          <NavLink style={{ cursor: "pointer" }} className={classnames({ active: topBorderTab === "2", })} onClick={() => { topBordertoggle("2"); }} >
                              <i className="mdi mdi-cart me-1 align-middle"></i> Vendas
                          </NavLink>
                      </NavItem>
                    )}

                    {moduloRotas && (
                      <NavItem>
                          <NavLink style={{ cursor: "pointer" }} className={classnames({ active: topBorderTab === "3", })} onClick={() => { topBordertoggle("3"); }} >
                              <i className="mdi mdi-google-maps align-middle me-1"></i>Rotas
                          </NavLink>
                      </NavItem>
                    )}
                  </Nav>

                  <TabContent activeTab={topBorderTab} className="text-muted">

                    <TabPane tabId="1">
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="nome-feira-input"
                            >
                              Nome
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="nome-feira-input"
                              placeholder="Informe o nome da feira"
                            />
                            <div className="invalid-feedback">
                              Informe o nome da feira.
                            </div>
                          </div>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Data início vendas
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="data-inicio-venda"
                              options={{
                                dateFormat: "d M, Y",
                                locale: Portuguese,
                              }}
                            />
                            <div className="invalid-feedback">
                              Informe a data de ínicio das vendas.
                            </div>
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Data fim vendas
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="data-fim-venda"
                              options={{
                                dateFormat: "d M, Y",
                                locale: Portuguese,
                              }}
                            />
                            <div className="invalid-feedback">
                              Informe a data de finalização das vendas.
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={6} hidden>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="feira-logo-img"
                            >
                              Logo
                            </Label>
                            <Input
                              className="form-control"
                              id="feira-logo-img"
                              type="file"
                              accept="image/png, image/gif, image/jpeg"
                              onChange={(e) => setLogoFile(e.target.files[0])}
                            />
                          </div>
                          {logoUrl && (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "0.5rem",
                              }}
                            >
                              <div style={{ position: "relative" }}>
                                <img
                                  src={
                                    typeof logoUrl === "string"
                                      ? logoUrl
                                      : URL.createObjectURL(logoUrl)
                                  }
                                  alt="Logo"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                />
                                <button
                                  type="button"
                                  onClick={removeImage}
                                  style={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                    background: "#ff4444",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                  }}
                                >
                                  <i className="ri-close-fill align-bottom" />
                                </button>
                             
                              </div>
                            </div>
                          )}
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="feira-logo-img"
                            >
                              Logo
                            </Label>

                            {!logoUrl && (
                              <Input
                                className="form-control"
                                id="feira-logo-img"
                                type="file"
                                accept="image/png, image/gif, image/jpeg"
                                onChange={handleFileChange}
                              />
                            )}

                            {logoUrl && (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "0.5rem",
                                }}
                              >
                                <div style={{ position: "relative" }}>
                                  <img
                                    src={
                                      typeof logoUrl === "string"
                                        ? logoUrl
                                        : URL.createObjectURL(logoUrl)
                                    }
                                    alt="Logo"
                                    style={{
                                      width: "80px",
                                      height: "80px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                    }}
                                  />
                                  <button
                                    type="button"
                                    onClick={removeImage}
                                    style={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                    background: "#ff4444",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50%",
                                    cursor: "pointer"
                                  }}
                                >
                                  <i className="ri-close-fill align-bottom" />
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Data início realização
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="data-inicio"
                              options={{
                                dateFormat: "d M, Y",
                                locale: Portuguese,
                              }}
                            />
                            <div className="invalid-feedback">
                              Informe a data de ínicio da feira.
                            </div>
                          </div>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Data fim realização
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="data-fim"
                              options={{
                                dateFormat: "d M, Y",
                                locale: Portuguese,
                              }}
                            />
                            <div className="invalid-feedback">
                              Informe a data de fim da feira.
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div className="mb-3">
                        <Label className="form-label">Breve Descrição</Label>
                        <textarea
                          className="form-control"
                          id="feira-descricao-input"
                          rows="6"
                          defaultValue=""
                        ></textarea>
                      </div>

                      <Row>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="whatsapp-input"
                            >
                              Whatsapp Principal
                            </Label>
                            <InputMask
                              className="form-control"
                              mask="(99) 99999-9999"
                              value={whatsapp}
                              onChange={(e) => setWhatsapp(e.target.value)}
                              placeholder="(00) 00000-0000"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="telefone-input"
                            >
                              Telefone
                            </Label>
                            <InputMask
                              className="form-control"
                              mask="(99) 99999-9999"
                              value={telefone}
                              id="telefone-input"
                              onChange={(e) => setTelefone(e.target.value)}
                              placeholder="Informe o telefone para contato"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="email-input">
                              E-mail Principal
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="email-input"
                              placeholder="Informe o email da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="youtube-input"
                            >
                              Youtube
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="youtube-input"
                              placeholder="Informe o youtube da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="instagram-input"
                            >
                              Instagram
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="instagram-input"
                              placeholder="Informe o instagram da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="facebook-input"
                            >
                              Facebook
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="facebook-input"
                              placeholder="Informe o facebook da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="linkedin-input"
                            >
                              Linkedn
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="linkedin-input"
                              placeholder="Informe o linkedn da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="twitter-input"
                            >
                              Twitter
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="twitter-input"
                              placeholder="Informe o twitter da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="bluesky-input"
                            >
                              BlueSky
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="bluesky-input"
                              placeholder="Informe o bluesky da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="spotify-input"
                            >
                              Spotify
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="spotify-input"
                              placeholder="Informe o spotify da feira"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="tiktok-input"
                            >
                              Tiktok
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="tiktok-input"
                              placeholder="Informe o tiktok da feira"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={2}>
                          <div className="mb-3">
                            <Label className="form-label">CEP</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="cep-input"
                              placeholder="Informe o CEP"
                              onBlur={(e) => buscarCep(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="mb-3">
                            <Label className="form-label">Estado</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="estado-input"
                              placeholder="Informe o estado"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label">Cidade</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="cidade-input"
                              placeholder="Informe a cidade"
                            />
                          </div>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-3">
                            <Label className="form-label">Bairro</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="bairro-input"
                              placeholder="Bairro"
                            />
                          </div>
                        </Col>

                        <Col lg={2}>
                          <div className="mb-3">
                            <Label className="form-label">Número</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="numero-input"
                              placeholder="Número"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={8}>
                          <div className="mb-3">
                            <Label className="form-label">Endereço</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="endereco-input"
                              placeholder="Rua, Avenida, etc."
                            />
                          </div>
                        </Col>

                        <Col lg={4}>
                          <div className="mb-3">
                            <Label className="form-label">Complemento</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="complemento-input"
                              placeholder="Complemento (opcional)"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={3}>
                          <div className="mb-3">
                            <li className="d-flex">
                              <div className="flex-shrink-0">
                                <div className="form-check form-switch form-switch-lg">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="ativo"
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <label
                                  htmlFor="ativo"
                                  className="form-check-label fs-14"
                                >
                                  Ativa
                                </label>
                                <p className="text-muted">
                                  Feira está ativa ou inativa
                                </p>
                              </div>
                            </li>
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <li className="d-flex">
                              <div className="flex-shrink-0">
                                <div className="form-check form-switch form-switch-lg">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="habilitada_vendas"
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <label
                                  htmlFor="habilitada_vendas"
                                  className="form-check-label fs-14"
                                >
                                  Habilitar Mapa Vendas
                                </label>
                                <p className="text-muted">
                                  Página para reservar e comprar os espaços da
                                  feira fica on-line
                                </p>
                              </div>
                            </li>
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <li className="d-flex">
                              <div className="flex-shrink-0">
                                <div className="form-check form-switch form-switch-lg">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="renovacao"
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <label
                                  htmlFor="renovacao"
                                  className="form-check-label fs-14"
                                >
                                  Habilitar Mapa de Renovações
                                </label>
                                <p className="text-muted">
                                  Página para renovar as reservas dos espaços
                                  fica disponível
                                </p>
                              </div>
                            </li>
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <li className="d-flex">
                              <div className="flex-shrink-0">
                                <div className="form-check form-switch form-switch-lg">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="habilitada_rotas"
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <label
                                  htmlFor="habilitada_rotas"
                                  className="form-check-label fs-14"
                                >
                                  Habilitar Rotas
                                </label>
                                <p className="text-muted">
                                  Serviço de rotas no parque da feira
                                </p>
                              </div>
                            </li>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={12}>
                          <div className="mb-3">
                              <Label className="form-label">Módulos da Feira</Label>
                              <p className="text-muted">Selecione os módulos que estarão ativos para esta feira.</p>
                          </div>
                        </Col>
                        <Col md={6}>
                            <Card 
                                className={`card-body ${moduloVendas ? 'border-primary' : ''}`} 
                                style={cardCursorPointer} 
                                onClick={() => setModuloVendas(!moduloVendas)}
                            >
                                <div className="d-flex">
                                    <div className="flex-shrink-0 me-3">
                                        <div className="avatar-xs">
                                            <div className="avatar-title rounded-circle bg-primary-subtle text-primary fs-20">
                                                <i className="mdi mdi-cart"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-grow-1">
                                        <h5 className="fs-15">Módulo de Vendas</h5>
                                        <p className="text-muted mb-0">Habilita o mapa interativo, gestão de espaços e vendedores.</p>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <div className="form-check form-switch form-switch-lg">
                                            <Input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              id="usa_vendas"
                                              checked={moduloVendas}
                                              onChange={(e) => setModuloVendas(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card 
                                className={`card-body ${moduloRotas ? 'border-primary' : ''}`}
                                style={cardCursorPointer} 
                                onClick={() => setModuloRotas(!moduloRotas)}
                            >
                                <div className="d-flex">
                                    <div className="flex-shrink-0 me-3">
                                        <div className="avatar-xs">
                                            <div className="avatar-title rounded-circle bg-primary-subtle text-primary fs-20">
                                                <i className="mdi mdi-google-maps"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-grow-1">
                                        <h5 className="fs-15">Módulo de Rotas</h5>
                                        <p className="text-muted mb-0">Habilita o serviço de rotas e pontos de interesse no parque.</p>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <div className="form-check form-switch form-switch-lg">
                                            <Input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              id="usa_rotas"
                                              checked={moduloRotas}
                                              onChange={(e) => setModuloRotas(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                      </Row>

                      <div className="text-end mb-4">
                        <button
                          type="submit"
                          className="btn btn-success w-sm"
                          onClick={salvarFeira}
                        >
                          Salvar
                        </button>
                      </div>
                    </TabPane>

                    {moduloVendas && (
                      <TabPane tabId="2" id="nav-border-justified-profile">
                        <Nav pills className="nav-custom-outline nav-primary mb-3" role="tablist">
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "1" })}
                              onClick={() => {
                                setActiveTabVendas("1");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Configuração
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "2" })}
                              onClick={() => {
                                setActiveTabVendas("2");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Adicionais
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "3" })}
                              onClick={() => {
                                setActiveTabVendas("3");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              KVA
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "4" })}
                              onClick={() => {
                                setActiveTabVendas("4");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Tipos de Espaços
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "5" })}
                              onClick={() => {
                                setActiveTabVendas("5");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Estacionamento
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "6" })}
                              onClick={() => {
                                setActiveTabVendas("6");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Pavilhão
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "7" })}
                              onClick={() => {
                                setActiveTabVendas("7");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Espaços
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "8" })}
                              onClick={() => {
                                setActiveTabVendas("8");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Mapa
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "9" })}
                              onClick={() => {
                                setActiveTabVendas("9");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Comercial
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "10" })}
                              onClick={() => {
                                setActiveTabVendas("10");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Espaços x Vendedor
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "11" })}
                              onClick={() => {
                                setActiveTabVendas("11");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Permissão
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({ active: activeTabVendas === "12" })}
                              onClick={() => {
                                setActiveTabVendas("12");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Expositores
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({
                                active: activeTabVendas === "13",
                                disabled: !habilitadaVendas,
                              })}
                              onClick={() => {
                                if (habilitadaVendas) {
                                  setActiveTabVendas("13");
                                } else {
                                  toast.warning(
                                    "A aba de exportação está desabilitada. Habilite as vendas para acessar."
                                  );
                                }
                              }}
                              type="button"
                              style={
                                !habilitadaVendas
                                  ? { cursor: "not-allowed", opacity: 0.5 }
                                  : {}
                              }
                            >
                              <i className="far fa-envelope"></i>
                              Exportar
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              to="#"
                              className={classnames({
                                active: activeTabVendas === "14",
                                disabled: !habilitadaVendas,
                              })}
                              onClick={() => {
                                setActiveTabVendas("14");
                              }}
                              type="button"
                            >
                              <i className="far fa-envelope"></i>
                              Manutenção
                            </NavLink>
                          </NavItem>
                        </Nav>
                          <TabContent activeTab={activeTabVendas}>
                            <TabPane tabId="1">
                              {feiraSalvaId && activeTabVendas === "1" ? (
                                <TelaConfiguracaoFeira
                                  feiraId={feiraSalvaId}
                                  editando={isEditando}
                                />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="2">
                              {feiraSalvaId && activeTabVendas === "2" ? (
                                <TagFeiraForm
                                  feiraId={feiraSalvaId}
                                  editando={isEditando}
                                />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  adicionais.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="3">
                                {feiraSalvaId && activeTabVendas === "3" ? (
                                  <TelaConfiguracoesKVA
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar valores cobrados de KVA
                                  </div>
                                )}
                              
                            </TabPane>

                            <TabPane tabId="4">
                              {feiraSalvaId && activeTabVendas === "4" ? (
                                <TelaConfiguracoesTipoEspaco
                                  feiraId={feiraSalvaId}
                                  editando={isEditando}
                                />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os tipos
                                  de espaços.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="5">
                              {feiraSalvaId && activeTabVendas === "5" ? (
                                
                                <TelaEstacionamentoFeira
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                          
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  estacionamentos.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="6">
                              {feiraSalvaId && activeTabVendas === "6" ? (
                                
                                  <TelaPavilhaoFeira
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                  
                          
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  pavilhões.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="7">
                              {feiraSalvaId && activeTabVendas === "7" ? (
                                
                                  <ListaEspacos
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                  
                          
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  espaços.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="8">
                              {feiraSalvaId && activeTabVendas === "8" ? (
                                
                                  <TelaMapaUpload
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                  
                          
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  espaços.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="9">
                              {feiraSalvaId && activeTabVendas === "9" ? (
                                <TelaComercialFeira
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar o
                                  comercial.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="10">
                              {feiraSalvaId && activeTabVendas === "10" ? (
                                <TelaEstandeVendedor
                                  feiraId={feiraSalvaId}
                                  editando={isEditando}
                                />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  espaços x vendedores.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="11">
                              
                              {feiraSalvaId && activeTabVendas === "11" ? (
                                <DashboardConfig
                                  feiraId={feiraSalvaId}
                                  editando={isEditando}
                                />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar as permissões
                                </div>
                              )}
                              
                            </TabPane>

                            <TabPane tabId="12">
                              
                              {feiraSalvaId && activeTabVendas === "12" ? (
                                
                                <ListaExpositores
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de visualizar os expositores
                                </div>
                              )}
                            </TabPane>
                          
                            <TabPane tabId="13">
                              {feiraSalvaId && activeTabVendas === "13" ? (
                                 <div className="card mt-4">
                                      <div className="card-header d-flex justify-content-between align-items-center">
                                      
                                        <div className="d-flex gap-2">
                                          <button 
                                            className="btn btn-primary btn-sm"
                                            onClick={() => mapaRef.current?.exportImage()}
                                          >
                                            Baixar Imagem (PNG)
                                          </button>
                                          <button 
                                            className="btn btn-danger btn-sm"
                                            onClick={() => mapaRef.current?.exportPDF()}
                                          >
                                            Baixar PDF
                                          </button>
                                        </div>
                                      </div>
                                      <div className="card-body" style={{ height: '700px', position: 'relative' }}>
                                        <FeiraProvider idFeira={feiraSalvaId}>
                                          <MapaVisualizador ref={mapaRef} />
                                        </FeiraProvider>
                                      </div>
                                    </div>
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de configurar os
                                  espaços.
                                </div>
                              )}
                            </TabPane>

                            <TabPane tabId="14">
                              {feiraSalvaId && activeTabVendas === "14" ? (
                                <FeiraProvider idFeira={feiraSalvaId}>
                                  <MapaGerenciamento feiraId={feiraSalvaId}
                                    editando={isEditando}/>
                                </FeiraProvider>
                              ) : (
                                <div className="alert alert-warning">
                                  Salve os dados da feira antes de realizar a manutenção
                                </div>
                              )}
                            </TabPane>
                          </TabContent>

                      </TabPane>
                    )}

                    {moduloRotas && (
                      <TabPane tabId="3" id="nav-border-justified-messages">
                        <Nav
                          pills className="nav-custom-outline nav-primary mb-3"
                          role="tablist">
                            <NavItem>
                              <NavLink 
                                style={{ cursor: "pointer" }} 
                                className={classnames({ active: activeTabRotas === "1" })}
                                onClick={() => {
                                  setActiveTabRotas("1");
                                }}
                                >
                                <i className="far fa-envelope"></i>
                                Configuração
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "2" })}
                                onClick={() => {
                                  setActiveTabRotas("2");
                                }}
                                type="button"
                              >
                                <i className="far fa-envelope"></i>
                                Tipos de Espaços
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "3" })}
                                onClick={() => {
                                  setActiveTabRotas("3");
                                }}
                              
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Pavilhões
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "4" })}
                                onClick={() => {
                                  setActiveTabRotas("4");
                                }}
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Setores
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "5" })}
                                onClick={() => {
                                  setActiveTabRotas("5");
                                }}
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Categorias
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "6" })}
                                onClick={() => {
                                  setActiveTabRotas("6");
                                }}
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Áreas de interesse
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "7" })}
                                onClick={() => {
                                  setActiveTabRotas("7");
                                }}
                              style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Expositores
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "8" })}
                                onClick={() => {
                                  setActiveTabRotas("8");
                                }}
                              style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Espaços
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "9" })}
                                onClick={() => {
                                  setActiveTabRotas("9");
                                }}
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Mapa
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "10" })}
                                onClick={() => {
                                  setActiveTabRotas("10");
                                }}
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Destinos x Caminhos
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                to="#"
                                className={classnames({ active: activeTabRotas === "11" })}
                                onClick={() => {
                                  setActiveTabRotas("11");
                                }}
                                style={{ cursor: "pointer" }} 
                              >
                                <i className="far fa-envelope"></i>
                                Rotas 
                              </NavLink>
                            </NavItem>


                        </Nav>
                        <TabContent activeTab={activeTabRotas}>
                              <TabPane tabId="1">
                                {feiraSalvaId && activeTabRotas === "1" ? (
                                  <TelaConfiguracaoRota
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar.
                                  </div>
                                )}
                              </TabPane>
                              
                              <TabPane tabId="2">
                                {feiraSalvaId && activeTabRotas === "2" ? (
                                  <TelaConfiguracoesTipoEspaco
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os tipos
                                    de espaços.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="3">
                                {feiraSalvaId && activeTabRotas === "3" ? (
                                  <TelaPavilhaoFeira
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os
                                    adicionais.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="4">
                                  {feiraSalvaId && activeTabRotas === "4" ? (
                                    <TelaSetor
                                      feiraId={feiraSalvaId}
                                      editando={isEditando}
                                    />
                                  ) : (
                                    <div className="alert alert-warning">
                                      Salve os dados da feira antes de configurar valores cobrados de KVA
                                    </div>
                                  )}
                                
                              </TabPane>

                              <TabPane tabId="5">
                                {feiraSalvaId && activeTabRotas === "5" ? (
                                  <TelaCategoria
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os tipos
                                    de espaços.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="6">
                                {feiraSalvaId && activeTabRotas === "6" ? (
                                  
                                    <TelaAreaInteresse
                                      feiraId={feiraSalvaId}
                                      editando={isEditando}
                                    />
                                    
                            
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os
                                    espaços.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="7">
                                {feiraSalvaId && activeTabRotas === "7" ? (
                                <ListaExpositores
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                    rota={true}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os expositores.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="8">
                                {feiraSalvaId && activeTabRotas === "8" ? (
                                <ListaEspacosRota
                                    feiraId={feiraSalvaId}
                                    editando={isEditando}
                                    rota={true}
                                  />
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de cadastrar os espaços.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="9">
                                {feiraSalvaId && activeTabRotas === "9" ? (
                                  <CadastroMapaRotaExpositor
                                      feiraId={feiraSalvaId}
                                      editando={isEditando}
                                    />
                                    
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os
                                    espaços x expositores.
                                  </div>
                                )}
                              </TabPane>

                              <TabPane tabId="10">
                                
                              {feiraSalvaId && activeTabRotas === "10" ? (
                                  <CadastroRoteamentoMapa
                                      feiraId={feiraSalvaId}
                                      editando={isEditando}
                                    />
                                    
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os
                                    espaços x expositores.
                                  </div>
                                )}
                                
                              </TabPane>

                              <TabPane tabId="11">
                                
                              {feiraSalvaId && activeTabRotas === "11" ? (
                                  <VisualizacaoRotaCadastro feiraId={feiraSalvaId} />
                                    
                                ) : (
                                  <div className="alert alert-warning">
                                    Salve os dados da feira antes de configurar os
                                    espaços x expositores.
                                  </div>
                                )}
                              </TabPane>

                             

                        </TabContent>
                      </TabPane>
                    )}

                  </TabContent>

               </CardBody> 

                <CardFooter>
                  <div className="text-start mb-4">
                    <button
                      type="submit"
                      className="btn btn-primary w-sm me-1"
                      onClick={() =>
                        navigate("/feiras-lista", { replace: true })
                      }
                    >
                      Voltar
                    </button>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CadastroFeira;
